import { StorableObject } from "@app/core/storable-object";

export class IsWorkingOffline extends StorableObject{
    constructor(){
        super();
    }

    public isEnabled: boolean = true;
}